import React from 'react';
import ProceedingStatusForm from '../components/ProceedingStatus/ProceedingStatusForm';

export default function ProceedingStatusPage() {
  return (
    <>
      <ProceedingStatusForm />
    </>
  );
}
